/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteAccount.defs'
export { main as default } from './deleteAccount.defs'
